import { useLoadScript } from '@react-google-maps/api'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { User } from 'react-feather'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import handleToast from '../../../../components/toaster'
import apiClient from '../../../../utils/backend'
import { fiscalConditionOptions } from '../../utilies/fiscalConditionOptions'

const useEditDentist = () => {
  const history = useHistory()
  const [loadingData, setLoadingData] = useState(false)
  const [avatar, setAvatar] = useState(null)
  const [showProfile, setShowProfile] = useState(false)
  const [avatarLink, setAvatarLink] = useState(null)
  const [genderObject, setGenderObject] = useState(null)
  const [fiscalConditionObject, setFiscalConditionObject] = useState()
  const [documentoDeIdentidad, setDocumentoDeIdentidad] = useState(null)
  const [requiredData, setRequiredData] = useState({
    name: null,
    surname: null,
    email: null,
    gender: null,
    birthdate: null,
  })
  const [personalData, setPersonalData] = useState({
    id: null,
    accreditation_course: null,
    profilePhoto: null,
    phone_number: null,
    cuit: null,
    fiscal_condition: null,
    national_enrollment: null,
    provintial_enrollment: null,
    facebook: null,
    instagram: null,
    twitter: null,
    web: null,
  })
  const [profile, setProfile] = useState({
    sao: false,
    study_group: false,
    sg_team: null,
    sg_type: null,
    sg_level: null,
  })
  const [errorField, setErrorField] = useState({
    name: '',
    surname: '',
    gender: '',
    birthdate: '',
    email: '',
    accreditation_course: '',
    cuit: '',
    profile: '',
    phone_number: '',
    national_enrollment: '',
    provintial_enrollment: '',
  })
  const [directions, setDirections] = useState([])
  const { countryId } = useSelector((reduxState) => reduxState.userReducer)
  const isArgentine = countryId === 1
  const isUruguayan = countryId === 2
  const isColombian = countryId === 4
  const isChilean = countryId === 5
  const dentistIdPath = window.location.pathname.split('/')[2]

  const getBase64 = (file, cb) => {
    let reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = function () {
      cb(reader.result)
    }
    reader.onerror = function (error) {
      console.log('Error: ', error)
    }
  }

  const handleSetErrors = (err) => {
    let profileError = false
    if (
      err['profile.sg_type'] ||
      err['profile.sg_team'] ||
      err['profile.sg_level']
    )
      profileError = true

    setErrorField({
      ...errorField,
      name: err['user.name'] !== null && err['user.name'],
      surname: err['user.surname'] !== null && err['user.surname'],
      gender: err['user.gender'] !== null && err['user.gender'],
      email: err['user.email'] !== null && err['user.email'],
      cuit: err['dentist.cuit'] !== null && err['dentist.cuit'],
      profile: profileError,
      national_enrollment:
        err['dentist.national_enrollment'] !== null &&
        err['dentist.national_enrollment'],
      provintial_enrollment:
        err['dentist.provintial_enrollment'] !== null &&
        err['dentist.provintial_enrollment'],
      accreditation_course:
        err['dentist.accreditation_course'] !== null &&
        err['dentist.accreditation_course'],
    })
  }

  const cleanError = (errName) => {
    setErrorField({ ...errorField, [errName]: null })
  }

  // redirect function
  const handleRedirect = () => {
    handleToast(
      'success',
      'Los datos del Odontólogo se guardaron correctamente'
    )
    setTimeout(() => {
      history.replace('/odontologos')
    }, 3000)
  }

  // send data
  const handleRequest = async () => {
    if (
      directions.length === 1 &&
      (!directions[0].street_address ||
        !directions[0].street_number ||
        !directions[0].hood ||
        !directions[0].zip_code ||
        !directions[0].province ||
        !directions[0].country ||
        !directions[0].city)
    ) {
      return handleToast('error', 'Se necesita al menos una dirección')
    }
    setLoadingData(true)
    handleToast('updating', 'Guardando los cambios...')
    const data = {
      user: {
        ...requiredData,
      },
      dentist: {
        ...personalData,
      },
      profile,
    }

    try {
      const res = await apiClient.put(`api/dentists/${dentistIdPath}`, data)
      if (res.data.success) return handleSendAvatar(res.data.data.id)
      setLoadingData(false)
      handleToast('error', '¡Error al actualizar el dentista!')
      handleSetErrors(res.data.errors)
    } catch (error) {
      handleToast('error', '¡Error al actualizar el dentista!')
      setLoadingData(false)
    }
  }

  //Request direction data
  const handleGetDirections = async () => {
    try {
      const res = await apiClient(`api/dentists/${dentistIdPath}/offices`)
      if (res.data.table.length === 0) {
        setDirections([
          {
            direction_name: `#Dirección 1`,
            toSave: false,
            inputId: 1,
            search: '',
            street_address: '',
            street_number: '',
            floor: '',
            apartment: '',
            hood: '',
            zip_code: '',
            province: '',
            city: '',
            country: '',
            lat: 0,
            lng: 0,
            visible: false,
          },
        ])
      } else {
        setDirections(res.data.table)
      }
    } catch (error) {
      console.log(error)
    }
  }

  //send avatar function
  const handleSendAvatar = async (dentistId) => {
    if (!avatar) return handleRedirect()
    const headers = {
      'Content-Type': 'multipart/form-data',
    }
    const data = new FormData()
    data.append('avatar', avatar)
    data.append('_method', 'PUT')
    try {
      const res = await apiClient.post(
        `/api/dentists/${dentistId}/avatar`,
        data,
        headers
      )
      if (res.status === 200) return handleRedirect()
      setLoadingData(false)
    } catch (err) {
      setLoadingData(false)
    }
  }

  //set initial state of gender
  const handleGender = (value) => {
    switch (value) {
      case 'f':
        setGenderObject({ label: 'Femenino', value: value })
        break
      case 'm':
        setGenderObject({ label: 'Masculino', value: value })
        break
      case 'o':
        setGenderObject({ label: 'Otro', value: value })
        break
      default:
        break
    }
  }

  //set initial state of FC
  const handleFisicalCondition = (value) => {
    setFiscalConditionObject({
      label: fiscalConditionOptions[value],
      value: value,
    })
  }

  const displayAvatarImage = () => {
    if (avatar || avatarLink)
      return (
        <img
          style={{
            cursor: 'pointer',
            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
            maxWidth: '200px',
            maxHeight: '200px',
            objectFit: 'cover',
          }}
          src={avatar ? personalData.profilePhoto : avatarLink}
          alt="Foto de perfil"
        />
      )

    return (
      <div
        className="flex"
        style={{
          cursor: 'pointer',
          boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
          paddingTop: 20,
          paddingBottom: 20,
          paddingRight: 40,
          paddingLeft: 40,
        }}
      >
        <User size={124} color="#ccc" />
        <p className="text-primary text-center">Avatar</p>
      </div>
    )
  }

  const addDirection = () => {
    if (directions.length === 5)
      return handleToast('error', 'Solo puede agregar hasta 5 direcciones')
    setDirections((prev) => [
      ...prev,
      {
        direction_name: `#Dirección ${directions.length + 1}`,
        inputId: directions.length + 1,
        toSave: false,
        search: '',
        street_address: '',
        street_number: '',
        floor: '',
        apartment: '',
        hood: '',
        zip_code: '',
        province: '',
        city: '',
        country: '',
        lat: 0,
        lng: 0,
        visible: false,
      },
    ])
  }

  const handleDeleteDirection = async (inputId, id) => {
    if (directions.length === 1)
      return handleToast('error', 'Se necesita al menos una dirección')
    let newDirections = directions
    if (id) {
      try {
        const res = await apiClient.delete(`api/offices/${id}`)
        handleToast('success', 'Dirección eliminada')
        handleGetDirections()
      } catch (error) {
        console.log(error)
      }
    } else {
      setDirections(
        newDirections.filter((direction) => direction.inputId !== inputId)
      )
      handleToast('success', 'Dirección eliminada')
    }
  }

  const handleSaveDirection = async (
    directionData,
    lat = '',
    lng = '',
    isWithoutGoogleApi = false
  ) => {
    let newDirectionData = {
      ...directionData,
      lat: lat.toString(),
      lng: lng.toString(),
    }
    delete directionData.toSave
    delete directionData.inputId
    try {
      if (directionData.id) {
        const res = await apiClient.patch(
          `api/offices/${directionData.id}`,
          isWithoutGoogleApi ? newDirectionData : directionData
        )
      } else {
        const res = await apiClient.post(
          `api/dentists/${dentistIdPath}/offices`,
          isWithoutGoogleApi ? newDirectionData : directionData
        )
      }
      handleGetDirections()
      handleToast('success', 'Dirección guardada exitosamente')
    } catch (error) {
      console.log(error)
    }
  }

  // Set data from current dentist
  useEffect(() => {
    if (!dentistIdPath) return
    const apiCall = async () => {
      const res = await apiClient.get(
        `/api/dentists/${dentistIdPath}?include=user,studyGroupRelationship`
      )
      let dentist = res.data.data
      let birthdate_polyfill = dentist.user.birthdate
        ?.split('/')
        .reverse()
        .join('-')

      setRequiredData({
        name: dentist.user.name,
        surname: dentist.user.surname,
        email: dentist.user.email,
        gender: dentist.user.gender,
        birthdate: birthdate_polyfill,
      })
      handleGender(dentist.user.gender)
      handleFisicalCondition(dentist.fiscal_condition)
      if (dentist.user.avatar) setAvatarLink(dentist.user.avatar)
      setPersonalData({
        id: dentist.id,
        profilePhoto: dentist.user.avatar,
        phone_number: dentist.phone_number,
        cuit: dentist.cuit,
        fiscal_condition: dentist.fiscal_condition,
        national_enrollment: dentist.national_enrollment,
        provintial_enrollment: dentist.provintial_enrollment,
        facebook: dentist.facebook,
        instagram: dentist.instagram,
        twitter: dentist.twitter,
        web: dentist.web,
        accreditation_course: moment(dentist.accreditation_course).format(
          'YYYY-MM-DD'
        ),
        cuit_prefix: dentist.cuit_prefix,
      })

      setDocumentoDeIdentidad({
        value: dentist.cuit_prefix,
        label: dentist.cuit_prefix,
      })
      setProfile({
        sao: dentist.sao,
        study_group: dentist.study_group,
        sg_type: dentist.study_group_relationship?.rol
          ? Number(dentist.study_group_relationship?.rol)
          : null,
        sg_level: dentist.study_group_relationship?.type
          ? Number(dentist.study_group_relationship?.type)
          : null,
        sg_team:
          dentist.study_group_relationship?.group_id !== null
            ? Number(dentist.study_group_relationship?.group_id)
            : null,
      })
      setShowProfile(true)
    }
    apiCall()
    handleGetDirections()
  }, [dentistIdPath])

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: 'AIzaSyA5GePOrq5a4XfoMbjjiLrOBYq4hpH7Cds',
    libraries: ['places'],
  })

  if (!isLoaded) return <div></div>

  return {
    directions,
    isArgentine,
    isUruguayan,
    isColombian,
    isChilean,
    countryId,
    personalData,
    requiredData,
    errorField,
    genderObject,
    documentoDeIdentidad,
    fiscalConditionObject,
    showProfile,
    profile,
    dentistIdPath,
    loadingData,
    displayAvatarImage,
    handleRequest,
    cleanError,
    getBase64,
    setAvatar,
    setPersonalData,
    setRequiredData,
    setGenderObject,
    setDocumentoDeIdentidad,
    setFiscalConditionObject,
    setProfile,
    setErrorField,
    handleDeleteDirection,
    handleSaveDirection,
    addDirection,
  }
}

export default useEditDentist
